import InsureProcessVehicalInfo from './InsureProcessVehicalInfo';
export default InsureProcessVehicalInfo;
